import NavSideBar from "../component/NavSideBar";

export default function Cards() {
  return (
    <NavSideBar>
        <div className="p-10 text-3xl font-bold">Cards</div>
    </NavSideBar>
  )
}
